export class LoanFormRequest {
  term: number;
  downPaymentPercent: number;
  downPaymenyCurrency: number;
  initialDate: string;
  firstFeeDate: string;
  firstFeeDateRaw: Date;
  fee: number;
  loanCode: string;
  maxDownPayment: number;
  maxTerm: number;
  minDownPayment: number;
  minTerm: number;
  rate:number;
  isAgreementCustomer:Boolean;

  constructor() {
    this.term = 0.0;
    this.downPaymentPercent = 0.0;
    this.downPaymenyCurrency = 0.0;
    this.initialDate = '';
    this.firstFeeDate = '';
    this.firstFeeDateRaw = new Date();
    this.fee = 0.0;
    this.loanCode = '';
    this.maxDownPayment = 0;
    this.minDownPayment = 0;
    this.minTerm = 0;
    this.maxTerm = 0;
    this.rate = 0;
    this.isAgreementCustomer = false;
  }
}
